
import { get, post } from './../Config/config';

export const VendorAPI = {

    get: (data) => get('/inventory/vendors', { params: data }),
    sendToMaitanance: (data) => post('/inventory/items/maintenance', data),
    returnFromMaintance: (data) => post('/inventory/items/maintenance-return', data),
}
